var exports = {
  "kL": "DMFriendsView.module__container___WVJsN0",
  "Em": "DMFriendsView.module__mainColumn___WVJsN0",
  "Qs": "DMFriendsView.module__content___WVJsN0",
  "sf": "DMFriendsView.module__searchWrapper___WVJsN0",
  "qc": "DMFriendsView.module__searchIcon___WVJsN0",
  "MJ": "DMFriendsView.module__tabBody___WVJsN0",
  "VW": "DMFriendsView.module__headerContent___WVJsN0",
  "cP": "DMFriendsView.module__titleSection___WVJsN0",
  "gr": "DMFriendsView.module__titleIcon___WVJsN0",
  "Qw": "DMFriendsView.module__titleText___WVJsN0",
  "yF": "DMFriendsView.module__divider___WVJsN0",
  "me": "DMFriendsView.module__tabsWrapper___WVJsN0",
  "xd": "DMFriendsView.module__tabsScroller___WVJsN0",
  "VD": "DMFriendsView.module__tabsInner___WVJsN0",
  "eg": "DMFriendsView.module__tabButton___WVJsN0",
  "vu": "DMFriendsView.module__active___WVJsN0",
  "zB": "DMFriendsView.module__primary___WVJsN0",
  "Lj": "DMFriendsView.module__tabContent___WVJsN0",
};

module.exports = exports;
